export default {
    convertedImages: {},
    conversionStatus: {}, // { [url]: 'pending' | 'success' | 'error' }
};